import { QueryClient } from '@tanstack/react-query';

/** App-wide QueryClient defaults; exported for tests that need a fresh client. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export const queryClient = createQueryClient();
